<div class="vtr-widget-storage-status">
    <div class="title" id="widget-storage-status-title" role="text">{{"dashboard.storage.title" | translate}}</div>
    <div class="storage left">
        <div class="storage-title" id="widget-storage-status-subtitle-disk" role="text">
            {{"dashboard.storage.disk" | translate}}<br/>
            <font [dir]="'dir' | translate">{{memoryDiskUsage.disk.freeText}} {{"dashboard.storage.free" | translate}}</font>
        </div>
        <div class="storage-content-container">
            <div class="storage-content">
                <img class="storage-wheel" [src]="'assets/images/dashboard/storage_gague.svg' | svgInline | async" />
                <div class="mask mask-left">
                    <div class="mask-obj"
                        [ngStyle]="{'transform': 'rotate('+calcLeftAngleDegree(memoryDiskUsage.disk)+'deg)'}">
                        <div class="mask-circle"></div>
                    </div>
                </div>
                <div class="mask mask-right">
                    <div class="mask-obj"
                        [ngStyle]="{'transform': 'rotate('+calcRightAngleDegree(memoryDiskUsage.disk)+'deg)'}">
                        <div class="mask-circle"></div>
                    </div>
                </div>
                <div class="storage-inner-circle"></div>
                <div class="storage-inner">
                    <span id="widget-storage-status-disk-text-used"
                        role="text"><font [dir]="'dir' | translate">{{memoryDiskUsage.disk.usedText}}</font>/</span>
                    <span id="widget-storage-status-disk-text-total"
                        role="text" [dir]="'dir' | translate">{{memoryDiskUsage.disk.totalText}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="storage right">
        <div class="storage-title" id="widget-storage-status-subtitle-memory" role="text">
            {{"dashboard.storage.memory" | translate}}<br/>
            <font [dir]="'dir' | translate">{{memoryDiskUsage.memory.freeText}} {{"dashboard.storage.available" | translate}}</font>
            
        </div>
        <div class="storage-content-container">
            <div class="storage-content">
				<img class="storage-wheel" [src]="'assets/images/dashboard/storage_gague.svg' | svgInline | async" />
                <div class="mask mask-left">
                    <div class="mask-obj"
                        [ngStyle]="{'transform': 'rotate('+calcLeftAngleDegree(memoryDiskUsage.memory)+'deg)'}">
                        <div class="mask-circle"></div>
                    </div>
                </div>
                <div class="mask mask-right">
                    <div class="mask-obj"
                        [ngStyle]="{'transform': 'rotate('+calcRightAngleDegree(memoryDiskUsage.memory)+'deg)'}">
                        <div class="mask-circle"></div>
                    </div>
                </div>
                <div class="storage-inner-circle"></div>
                <div class="storage-inner">
                    <span id="widget-storage-status-memory-text-used"
                        role="text"><font [dir]="'dir' | translate">{{memoryDiskUsage.memory.usedText}}</font>/</span>
                    <span id="widget-storage-status-memory-text-total"
                        role="text" [dir]="'dir' | translate">{{memoryDiskUsage.memory.totalText}}</span>
                        <span></span>
                </div>
            </div>
        </div>
    </div>
</div>